export default "__VITE_ASSET__C$fU_BpQ__"